import React, { useState } from "react";
import { Container, Paper, Button, CircularProgress, Snackbar, Alert } from "@mui/material";
import axios from "axios";
import BaseURL from "../../api/AppURL";

export default function DatabaseBackupPage() {
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const handleSnackbarClose = () => setSnackbar({ ...snackbar, open: false });

  const handleBackup = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("auth_token");

      const response = await axios.post(
        `${BaseURL}/admin/database/backup`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob", // to handle file download
        }
      );

      // Extract filename from Content-Disposition header
      const contentDisposition = response.headers["content-disposition"];
      let fileName = "backup.sql";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match && match[1]) {
          fileName = match[1];
        }
      }

      // Create a download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

      setSnackbar({ open: true, message: "Database backup downloaded successfully", severity: "success" });
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to take backup",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper sx={{ p: 3, textAlign: "center" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleBackup}
          disabled={loading}
          sx={{ fontWeight: "bold", px: 4, py: 1.5 }}
        >
          {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Take Backup"}
        </Button>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity={snackbar.severity} onClose={handleSnackbarClose}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}
